import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    enableEnergyLabelLink: true,
};
